// 注册接口
import api from '@edu-fe/api'
import Cookie from 'js-cookie'

const options = {
  method: 'post',
  formData: true
}

api.createModule({
  h5: api.create('/order/h5', options),
  weixin: api.create('/order/weixin', options),
  ali: api.create('/order/alipay/app', options),
  free: api.create('/order/free', options),
  status: api.create('/order/check_status'),
  hasBuy: api.create(`/my/is/buy?userId=${Cookie.get('openid')}`),
  coupon: api.create('/coupon/order'),
  payInfo: api.create('/order/pay_info'),
  bonus: (courseId = '') => api.create(`/money/total?courseId=${courseId}`)
}, 'PackageEduFePay')

export default api
